/* eslint-disable */

<template>
    <div>
        <BasicCard v-if="o_loading" v-bind:title="`Caricamento in corso`" class="pr-2">
            <v-card-text text-center>
                <v-progress-circular
                indeterminate
                size="64"
                width="7"
                color="primary"
                ></v-progress-circular>
            </v-card-text>
        </BasicCard>
        <div v-else>
            <v-hover><v-chip v-can="{obj_type:'organism', action: 'list'}"
                slot-scope="{ hover }"
                :class="`caption font-weight-thin text-uppercase mb-2 ml-2 text-center elevation-${hover ? 3 : 0}`"
                @click="close" absolute top left>
                <v-icon>keyboard_arrow_left</v-icon>back</v-chip>
            </v-hover>
            <BasicCard :key="org.updated" :title="org.name">
                <template v-slot:action>
                    <v-btn v-can="{obj_type:'organism', action: 'edit'}" fab small class="pa-2" text @click="editOrg"><v-icon>edit</v-icon></v-btn>
                </template>
                <div class="pa-2">
                    <div>
                        <i>P.IVA: <span class="text-subtitle-2">{{ org.piva }}</span></i> 
                        <i v-if="org.fiscal_code">, Codice Fiscale: <span class="text-subtitle-2">{{ org.fiscal_code }}</span><br/></i>
                        <i v-if="org.pec" class="pr-2" >PEC: <span class="text-subtitle-2">{{ org.pec }}</span></i>
                        <i v-if="org.unique_code">Codice Univoco: <span class="text-subtitle-2">{{ org.unique_code }}</span><br/></i>
                    </div>
                    <div text-left mt-2>
                        <i >Sede Legale:</i>
                        <span class="text-subtitle-2">
                            <span v-if="org.address"> {{org.address}}, {{org.addrNum}} -</span>
                            <span v-if="org.city"> {{org.city}} </span>
                            <span v-if="org.district">({{org.district}})</span>
                        </span>
                    </div>
                    <div v-if="org.contact_name || org.contact_email || org.contact_phone" text-left mt-2>
                        <i>Contatto:</i>
                        <span class="text-subtitle-2"> {{org.contact_name}}, {{org.contact_email}} - {{org.contact_phone}}</span>
                    </div>
                    <div v-if="org.contact_name || org.contact_email || org.contact_phone" text-left mt-2>
                        <i>Per ente emettitore - dati presenti su PDF per conformità Accredia:</i>
                        <span class="text-subtitle-2">Unioncamere - Organismo di ispezione di tipo {{org.inspection_type}}</span>
                        <span class="text-subtitle-2">Accredia - ISP N° {{org.inspection_nr}}</span>
                    </div>
                </div>
            </BasicCard>
            <PrimaryList
                :org_id="org_id"
                :lock_org="true"
            />
        </div>
        <OrgsDialog
            ref="orgs_dialog"
            v-on:saveOrg="saveOrg"
        />   
    </div>
        
</template>
<script>

import OrgsDialog from "./OrgsDialog"
import BasicCard from '../../components/utils/Basic_card'
import PrimaryList from "./PrimaryList"

// import _ from 'lodash'

export default {
    components: {BasicCard, PrimaryList, OrgsDialog},
    props: ['org_id', 'back'],
    data() {
        return {
            registry_data: {},
            o_loading: true,
            orgs: [],
            org: null
            
        }
    },
    async mounted() {
        this.o_loading = true
        this.currentTime = Date.now()
        console.log("current time in ms", this.currentTime)
        // this.org = await this.$store.state.$pouch.get('registry', this.org_id)
        await this.findOrg() 
        this.o_loading = false
    },
    methods: {
        async findOrg(){
            this.org = await this.$store.state.$pouch.get('registry', this.org_id)
        },
        editOrg() {
            this.$refs.orgs_dialog.reset(this.org._id);
        },
        async saveOrg(){
            await this.findOrg() 
        },
        close(){
            this.$router.push({path: this.back})
        }
    }
}   
</script>